import { useState, useEffect } from "react";
import Indication, { IndicationState } from "../../atoms/indication/Indication";
import ShopWithStock from "../../atoms/shopWithStock/ShopWithStock";
import styles from "./productDetailIndicators.module.scss";
import PropTypes from "prop-types";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import {
  replaceValue,
  getCookieValue,
} from "../../../utils/helperServices";
import {
  CustomContainer,
  connect,
  useDispatch,
} from "../../atoms/DependencyHelper";
import StockModal from "../../molecules/StockModal/StockModal";
import * as Analytics from "../../../services/analyticsUtag";
import config from "../../../config/index";
import { AlertDetails } from "../../../config/queries";
import ajaxService from "../../../utils/ajaxServices";
import { ALERT_SELECT } from "../../../Redux/actionTypes";
import labels from "../../../config/labels";
import Image from "../../atoms/image/image";

import types from "../../../config/types";

const ProductDetailIndicators = ({
  className,
  indicatorClass,
  isLowStock,
  isOutOfStock,
  quantity,
  showModal,
  productDetails,
  stockMessage,
  uniqueIndicationId,
  userLoggedIn,
  checkSelect,
  profileLoading,
  selectedOption,
  isBuyOptioon,
  isDeal,
  flag,
  promotionTag,
  geoLocationIsAllowed,
  nearestStore,
  isStoreStockServiceDown,
  isCandCEligible,
  isMiniApp
}) => {
  const [show, setShow] = useState(false);
  const [showPreOrderInfo, setShowPreOrderInfo] = useState(false);
  const [preOrderAvailable, setPreOrderAvailable] = useState("");
  const [preOrderAvailableDesc, setPreOrderAvailableDesc] = useState("");
  const env = config.env;
  const loginUrl = config.envConfigs[env].DIDLoginUrl;
  const dispatch = useDispatch();

  const [storeStockCheckStatusMessage, setStoreStockCheckStatusMessage] = useState([]);

  const handleClose = () => {
    setShow(false);
    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "sales_product_id",
        "sales_product_price",
        "sales_product_quantity",
        "visitor_login_status",
        "visitor_msisdn_hash",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_subscription_type",
        "page_site_section_lvl_1",
        "page_site_section_lvl_2",
        "page_site_section_lvl_3",
        "page_site_section_lvl_4",
      ]),
      page_form_event: "success",
      page_form_name:
        "shopping: devices: out of stock: email notification signup",
    });
  };

  async function getAlertData() {
    const alertResult = await ajaxService.fetchGraphQLPOSTRequest(
      AlertDetails,
      {
        productId: productDetails?.id,
      }
    );
    if (alertResult.productAlert == null) {
      setShow(false);
    } else {
      setShow(true);
    }
    dispatch({ type: ALERT_SELECT, payload: false });
  }

  useEffect(() => {
    if(promotionTag && promotionTag == types.TYPE_PREORDER) {
      fetchPreOrderContent();
    }
  },[promotionTag]);

  useEffect(() => {
    const JWTtoken = getCookieValue("vod-web-auth-token");
    if (checkSelect === true) {
      if (userLoggedIn && JWTtoken && productDetails?.id) {
        getAlertData();
      } else if (!JWTtoken && !profileLoading && !userLoggedIn) {
        let redirectURL = loginUrl + "?redirectUrl=" + window.location.href + (isMiniApp ? "&app=true" : "");
        window.location.replace(redirectURL);
      }
    }
  }, [checkSelect, userLoggedIn, profileLoading]);

  useEffect(() => {
    async function storeStockStatusMessages() {
      try {
        const messages = await ajaxService.httpGet(
          "drupalBaseUrl",
          "",
          "api",
          "storeStockCheckStatus",
        );
        setStoreStockCheckStatusMessage(messages?.sections?.[0]?.items);
      } catch (e) {
        console.log("deal-details: features : error: ", e)
      }
    }
    storeStockStatusMessages();
  }, [isCandCEligible]);

  const handleShow = async () => {
    dispatch({ type: ALERT_SELECT, payload: true });
    const analyticsData = {
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "sales_product_id",
        "sales_product_price",
        "sales_product_quantity",
        "sales_product_category",
        "visitor_login_status",
        "visitor_msisdn_hash",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_subscription_type",
        "page_site_section_lvl_1",
        "page_site_section_lvl_2",
        "page_site_section_lvl_3",
        "page_site_section_lvl_4",
      ]),
      link_type: "o",
      link_name: `shopping: devices: ${isDeal ? "deal details" : "product details"
        }: out of stock: notify me when its available online`,
    };
    Analytics.link(analyticsData);
  };

  const fetchPreOrderContent = async () => {
    const url = isDeal ? "preOrderDealDetail" : "preOrderProductDetail";
    try {
      const result = await ajaxService.httpGet(
        "drupalBaseUrl",
        "",
        "api",
        url
      );
      if (result?.sections[0]?.items) {
        if(isDeal) {
          setPreOrderAvailable(result.sections[0].items[1].title);
          setPreOrderAvailableDesc(result.sections[0].items[1].description.replace(/<[^>]+>/g, ''));
        } else {
          setPreOrderAvailable(result.sections[0].items[0].title);
          setPreOrderAvailableDesc(result.sections[0].items[0].description.replace(/<[^>]+>/g, ''));
        }
        setShowPreOrderInfo(true);
      }
    } catch (e) {
      console.error('[ProductDetailIndicators]', e);
    }
  };

  const renderCTA = () => <CTAButton
    key={`check-in-store`}
    // variant="solid white"
    className={`${styles["storeCard-button"]} ${styles["btn-in-store"]}`}
    variant="outline black"
    handleClick={showModal}
  >Check in-store stock now</CTAButton>

  const noStoreStockMsg = (index) => {
    if (!Array.isArray(storeStockCheckStatusMessage) || !storeStockCheckStatusMessage.length)
      return null;

    return (
      <div className={`d-flex ${indicatorClass}`}>
        <Image img_path={storeStockCheckStatusMessage && storeStockCheckStatusMessage[index]?.icon} img_width="19px" img_height="19px"></Image>
        <div className={styles["no-stock-store"]}>{storeStockCheckStatusMessage && storeStockCheckStatusMessage[index]?.title}</div>
      </div>
    );
  }

  const storeStockAvailable = () => {
    return (
      <>
        { storeStockCheckStatusMessage && (
          <Indication
            className={`mt-l ${indicatorClass}`}
            type={IndicationState.Good}
            state={storeStockCheckStatusMessage[0]?.title}
            description={storeStockCheckStatusMessage[0]?.description}
            uniqueIndication={uniqueIndicationId}
            preOrder={promotionTag && promotionTag == types.TYPE_PREORDER}
          />
        )}

        <ShopWithStock
          className={styles["shop-with-stock"]}
          shopName={nearestStore?.name}
          onClickHandler={showModal}
        />
        <div>
          <span className={styles["description"]}>
            * {labels.lbl_click_and_collect_msg}
          </span>
        </div>
      </>
    )
  }

  const noGeolocationAllowed = () => {
    return (
      <Indication
        className={`mt-l ${styles["in-stock-info"]} ${indicatorClass}`}
        type={IndicationState.Question}
        state={"We couldn't check stores near you *"}
        description={`* ${labels.lbl_click_and_collect_msg}`}
        uniqueIndication={uniqueIndicationId}
        extended={renderCTA()}
        preOrder={promotionTag && promotionTag == types.TYPE_PREORDER}
      />
    );
  }

  const isAvailableOnline = !isLowStock && !isOutOfStock && !showPreOrderInfo;
  const showQuantityLeft = !!(quantity
    && isLowStock
    && !isOutOfStock
    && isBuyOptioon
    && selectedOption === labels.lbl_custom_dropdown_prepaid_option
    && !showPreOrderInfo);

  return (
    <div className={styles.availabilityWrapper}>
      { isAvailableOnline && (
        <Indication
          className={indicatorClass}
          type={IndicationState.Good}
          state={'In stock'}
          description="We can have it delivered to you within "
          days="2-5 working days"
          uniqueIndication={uniqueIndicationId}
          preOrder={promotionTag && promotionTag == types.TYPE_PREORDER}
        />
      )}

      {showQuantityLeft
        && (
          <Indication
            className={indicatorClass}
            type={IndicationState.Warning}
            state={replaceValue("Only no left online!", "no", quantity)}
            description="We can have it delivered to you within "
            days="2-5 working days"
            uniqueIndication={uniqueIndicationId}
            preOrder={promotionTag && promotionTag == types.TYPE_PREORDER}
          />
        )}

      {isOutOfStock && (
        <>
          <StockModal
            show={show}
            handleClose={handleClose}
          />
          <Indication
            className={indicatorClass}
            type={
              isBuyOptioon
                ? selectedOption === labels.lbl_custom_dropdown_prepaid_option
                  ? IndicationState.Bad
                  : IndicationState.Warning
                : IndicationState.Bad
            }
            state={"Out of stock"}
            description={'But you can still order and get it within '}
            uniqueIndication={uniqueIndicationId}
            days={"2 - 5 weeks"}
            actionLabel={"Notify me when it's available online"}
            onActionClick={handleShow}
            preOrder={promotionTag && promotionTag == types.TYPE_PREORDER}
            showAction={(selectedOption != labels.lbl_custom_dropdown_upgrade_option
              || labels.lbl_custom_dropdown_upgrade_option_new_contract)
              && selectedOption != labels.lbl_custom_dropdown_deal_option
            }
          />
        </>
      )}

      {showPreOrderInfo && (
        <Indication
          className={indicatorClass}
          type={IndicationState.PreOrder}
          state={'Available for pre-order!'}
          description={"Select how you'd like to pay to continue"}
          uniqueIndication={uniqueIndicationId}
          preOrder={promotionTag && promotionTag == types.TYPE_PREORDER}
        />
      )}
    </div>
  );
};

ProductDetailIndicators.defaultProps = {
  className: "",
  isLowStock: false,
  isOutOfStock: false,
  isStoreStockServiceDown: false,
  isCandCEligible: true,
  isMiniApp: false,
  indicatorClass: "",
};

ProductDetailIndicators.propTypes = {
  className: PropTypes.string,
  indicatorClass: PropTypes.string,
  flag: PropTypes.bool,
  geoLocationIsAllowed: PropTypes.bool,
  isBuyOptioon: PropTypes.bool,
  isCandCEligible: PropTypes.bool,
  isDeal: PropTypes.bool,
  isLowStock: PropTypes.bool,
  isOutOfStock: PropTypes.bool,
  isStoreStockServiceDown: PropTypes.bool,
  nearestStore: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  productDetails: PropTypes.object,
  promotionTag: PropTypes.string,
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedOption: PropTypes.string,
  showModal: PropTypes.func,
  stockMessage: PropTypes.object,
  uniqueIndicationId: PropTypes.string,

  // Redux
  checkSelect: PropTypes.bool,
  isMiniApp: PropTypes.bool,
  profileLoading: PropTypes.bool,
  userLoggedIn: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  userLoggedIn: state.navDetails.isUserLoggedIn,
  checkSelect: state.alertSelect.alert,
  profileLoading: state.navDetails.isProfileLoading,
  isMiniApp: state.navDetails.isMiniApp,
});

export default connect(mapStateToProps)(ProductDetailIndicators);
